import { api } from '../core';
import { TIMELINE_UNDO_REDO_HISTORY_TAG } from '../constants';
import { setTimelineChronologyUndoRedoHistory, TimelineChronologyType } from '@/store';

export interface TimelineUndoRedoHistory {
  undone: number;
  applied: number;
}

type TimelineUndoRedoHistoryResponse = TimelineUndoRedoHistory;

type TimelineUndoRedoHistoryProps = {
  caseId: string;
};

export const getTimelineUndoRedoHistoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTimelineUndoRedoHistory: builder.query<TimelineUndoRedoHistoryResponse, TimelineUndoRedoHistoryProps>({
      query: ({ caseId }: TimelineUndoRedoHistoryProps) => {
        return {
          url: `timeline/history`,
          method: 'GET',
          params: {
            caseId: caseId
          }
        };
      },
      providesTags: (_result, _err, { caseId }) => [{ type: TIMELINE_UNDO_REDO_HISTORY_TAG, id: caseId }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(
              setTimelineChronologyUndoRedoHistory({
                key: TimelineChronologyType.TIMELINE,
                data: data
              })
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getTimelineUndoRedoHistory in onQueryStarted:', error);
          }
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetTimelineUndoRedoHistoryQuery } = getTimelineUndoRedoHistoryApi;
